/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 4144:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _typeof(t){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t,e){"object"===( false?0:_typeof(exports))&&"undefined"!="object"?module.exports=e(): true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (e),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):0}(this,function(){"use strict";var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),n=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),r={elements_selector:"img",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",data_poster:"poster",class_loading:"loading",class_loaded:"loaded",class_error:"error",load_delay:0,auto_unobserve:!0,callback_enter:null,callback_exit:null,callback_reveal:null,callback_loaded:null,callback_error:null,callback_finish:null,use_native:!1},a=function(t,e){var n,o=new t(e);try{n=new CustomEvent("LazyLoad::Initialized",{detail:{instance:o}})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized",!1,!1,{instance:o})}window.dispatchEvent(n)};var s=function(t,e){return t.getAttribute("data-"+e)},i=function(t,e,n){var o="data-"+e;null!==n?t.setAttribute(o,n):t.removeAttribute(o)},c=function(t){return"true"===s(t,"was-processed")},l=function(t,e){return i(t,"ll-timeout",e)},u=function(t){return s(t,"ll-timeout")},d=function(t,e,n,o){t&&(void 0===o?void 0===n?t(e):t(e,n):t(e,n,o))},f=function(t,e){t.loadingCount+=e,0===t._elements.length&&0===t.loadingCount&&d(t._settings.callback_finish,t)},_=function(t){for(var e,n=[],o=0;e=t.children[o];o+=1)"SOURCE"===e.tagName&&n.push(e);return n},v=function(t,e,n){n&&t.setAttribute(e,n)},g=function(t,e){v(t,"sizes",s(t,e.data_sizes)),v(t,"srcset",s(t,e.data_srcset)),v(t,"src",s(t,e.data_src))},m={IMG:function(t,e){var n=t.parentNode;n&&"PICTURE"===n.tagName&&_(n).forEach(function(t){g(t,e)});g(t,e)},IFRAME:function(t,e){v(t,"src",s(t,e.data_src))},VIDEO:function(t,e){_(t).forEach(function(t){v(t,"src",s(t,e.data_src))}),v(t,"poster",s(t,e.data_poster)),v(t,"src",s(t,e.data_src)),t.load()}},h=function(t,e){var n,o,r=e._settings,a=t.tagName,i=m[a];if(i)return i(t,r),f(e,1),void(e._elements=(n=e._elements,o=t,n.filter(function(t){return t!==o})));!function(t,e){var n=s(t,e.data_src),o=s(t,e.data_bg);n&&(t.style.backgroundImage='url("'.concat(n,'")')),o&&(t.style.backgroundImage=o)}(t,r)},p=function(t,e){o?t.classList.add(e):t.className+=(t.className?" ":"")+e},b=function(t,e){o?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},y=function(t,e,n){t.addEventListener(e,n)},E=function(t,e,n){t.removeEventListener(e,n)},w=function(t,e,n){E(t,"load",e),E(t,"loadeddata",e),E(t,"error",n)},I=function(t,e,n){var o=n._settings,r=e?o.class_loaded:o.class_error,a=e?o.callback_loaded:o.callback_error,s=t.target;b(s,o.class_loading),p(s,r),d(a,s,n),f(n,-1)},k=function(t,e){var n=function n(r){I(r,!0,e),w(t,n,o)},o=function o(r){I(r,!1,e),w(t,n,o)};!function(t,e,n){y(t,"load",e),y(t,"loadeddata",e),y(t,"error",n)}(t,n,o)},A=["IMG","IFRAME","VIDEO"],L=function(t,e){var n=e._observer;O(t,e),n&&e._settings.auto_unobserve&&n.unobserve(t)},x=function(t){var e=u(t);e&&(clearTimeout(e),l(t,null))},z=function(t,e){var n=e._settings.load_delay,o=u(t);o||(o=setTimeout(function(){L(t,e),x(t)},n),l(t,o))},O=function(t,e,n){var o=e._settings;!n&&c(t)||(A.indexOf(t.tagName)>-1&&(k(t,e),p(t,o.class_loading)),h(t,e),function(t){i(t,"was-processed","true")}(t),d(o.callback_reveal,t,e),d(o.callback_set,t,e))},N=function(t){return!!n&&(t._observer=new IntersectionObserver(function(e){e.forEach(function(e){return function(t){return t.isIntersecting||t.intersectionRatio>0}(e)?function(t,e,n){var o=n._settings;d(o.callback_enter,t,e,n),o.load_delay?z(t,n):L(t,n)}(e.target,e,t):function(t,e,n){var o=n._settings;d(o.callback_exit,t,e,n),o.load_delay&&x(t)}(e.target,e,t)})},{root:(e=t._settings).container===document?null:e.container,rootMargin:e.thresholds||e.threshold+"px"}),!0);var e},C=["IMG","IFRAME"],M=function(t,e){return function(t){return t.filter(function(t){return!c(t)})}((n=t||function(t){return t.container.querySelectorAll(t.elements_selector)}(e),Array.prototype.slice.call(n)));var n},S=function(t){var e=t._settings;e.container.querySelectorAll("."+e.class_error).forEach(function(t){b(t,e.class_error),function(t){i(t,"was-processed",null)}(t)}),t.update()},R=function(e,n){var o;this._settings=function(t){return _extends({},r,t)}(e),this.loadingCount=0,N(this),this.update(n),o=this,t&&window.addEventListener("online",function(t){S(o)})};return R.prototype={update:function(t){var n,o=this,r=this._settings;(this._elements=M(t,r),!e&&this._observer)?(function(t){return t.use_native&&"loading"in HTMLImageElement.prototype}(r)&&((n=this)._elements.forEach(function(t){-1!==C.indexOf(t.tagName)&&(t.setAttribute("loading","lazy"),O(t,n))}),this._elements=M(t,r)),this._elements.forEach(function(t){o._observer.observe(t)})):this.loadAll()},destroy:function(){var t=this;this._observer&&(this._elements.forEach(function(e){t._observer.unobserve(e)}),this._observer=null),this._elements=null,this._settings=null},load:function(t,e){O(t,this,e)},loadAll:function(){var t=this;this._elements.forEach(function(e){L(e,t)})}},t&&function(t,e){if(e)if(e.length)for(var n,o=0;n=e[o];o+=1)a(t,n);else a(t,e)}(R,window.lazyLoadOptions),R});
//# sourceMappingURL=lazyload.min.js.map


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
/* harmony import */ var vanilla_lazyload__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4144);
/* harmony import */ var vanilla_lazyload__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vanilla_lazyload__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }


/**
 * Constants for event names and selectors.
 */
var EVENTS = {
  ADD_TO_CART: 'add-to-cart',
  SELECT_VARIANT: 'select-variant',
  VARIANT_CHANGE: 'variant:change',
  CLICK: 'click',
  KEYDOWN: 'keydown',
  CHANGE: 'change'
};
var CLASSES = {
  SELECTED: 'selected',
  VISIBLE: 'visible'
};
var SELECTORS = {
  ADD_TO_CART: '.serialisation-modal__add-to-cart',
  SELECT_VARIANT: '[js-select-variant]',
  CLOSE_BUTTON: '.close-button',
  VARIANT_SELECTS: 'variant-selects',
  VARIANT_COLUMN: '.serialisation-modal__variant-column',
  MODAL: 'serialisation-modal',
  SCROLL_TO_VARIANT: '[js-scroll-to-variant]',
  SELECT_LINK: 'select-link',
  MOBILE_SELECT_VARIANT: '[js-mobile-select-variant]',
  ERROR_MESSAGE: '.serialisation-modal__error-message'
};

/**
 * A custom element for displaying a modal with lazy-loaded content.
 * Provides controls for selecting variants and adding them to cart.
 * @class
 * @extends HTMLElement
 */
var SerialisationModal = /*#__PURE__*/function (_HTMLElement) {
  function SerialisationModal() {
    var _this;
    _classCallCheck(this, SerialisationModal);
    _this = _callSuper(this, SerialisationModal);
    _this.bindEventHandlers();
    _this.isMobile = window.matchMedia('(max-width: 48rem)').matches;
    _this.currentVariantSerial = _this.dataset.currentVariantSerial;
    _this.originalVariantSerial = _this.dataset.currentVariantSerial;
    return _this;
  }

  /**
   * Bind event handlers to maintain consistent context
   */
  _inherits(SerialisationModal, _HTMLElement);
  return _createClass(SerialisationModal, [{
    key: "bindEventHandlers",
    value: function bindEventHandlers() {
      this.handleOutsideClick = this.handleOutsideClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleAddToCart = this.handleAddToCart.bind(this);
      this.handleSelectVariant = this.handleSelectVariant.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleScrollToVariant = this.handleScrollToVariant.bind(this);
      this.handleMobileSelectVariant = this.handleMobileSelectVariant.bind(this);
    }

    /**
     * Initialize lazy loading instance
     */
  }, {
    key: "initializeLazyLoad",
    value: function initializeLazyLoad() {
      if (this.lazyLoad) {
        this.lazyLoad.destroy();
      }
      this.lazyLoad = new (vanilla_lazyload__WEBPACK_IMPORTED_MODULE_0___default())({
        container: this
      });
      this.lazyLoad.update();
    }

    /**
     * Set up the component when it's connected to the DOM
     */
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setupEventListeners();
      this.initializeLazyLoad();
    }

    /**
     * Show the modal
     */
  }, {
    key: "show",
    value: function show() {
      this.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
      var selectedElement = this.querySelector('[data-selected="true"][data-serial]');
      if (selectedElement) {
        var serial = selectedElement.dataset.serial;
        this.currentVariantSerial = serial;
        this.originalVariantSerial = serial;
      }
    }

    /**
     * Hide the modal
     */
  }, {
    key: "hide",
    value: function hide() {
      this.classList.add('hidden');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open');
    }

    /**
     * Called when custom element is disconnected from the DOM
     */
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.cleanup();
    }

    /**
     * Reinitialize the modal after content update
     */
  }, {
    key: "reinitialize",
    value: function reinitialize() {
      this.initializeLazyLoad();
      this.setupEventListeners();
    }

    /**
     * Remove event listeners
     */
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      var _this2 = this;
      this.removeEventListener(EVENTS.CLICK, this.handleOutsideClick);
      document.removeEventListener(EVENTS.KEYDOWN, this.handleKeydown);
      this.querySelectorAll(SELECTORS.ADD_TO_CART).forEach(function (button) {
        return button.removeEventListener(EVENTS.CLICK, _this2.handleAddToCart);
      });
      this.querySelectorAll(SELECTORS.SELECT_VARIANT).forEach(function (button) {
        return button.removeEventListener(EVENTS.CLICK, _this2.handleSelectVariant);
      });
      this.querySelectorAll(SELECTORS.SCROLL_TO_VARIANT).forEach(function (button) {
        return button.removeEventListener(EVENTS.CLICK, _this2.handleScrollToVariant);
      });
      var closeButton = this.querySelector(SELECTORS.CLOSE_BUTTON);
      if (closeButton) {
        closeButton.removeEventListener(EVENTS.CLICK, this.handleCloseClick);
      }
    }

    /**
     * Handle clicking outside content area in the modal
     * @param {MouseEvent} event
     */
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick(event) {
      if (event.target.hasAttribute('js-select-variant')) return;
      if (event.target === this) this.cleanup();
    }

    /**
     * Handle Escape keydown to close the modal
     * @param {KeyboardEvent} event
     */
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      if (event.key === 'Escape') this.cleanup();
    }

    /**
     * Handle the click event for 'Scroll to Variant' button
     * @param {MouseEvent} e
     */
  }, {
    key: "handleScrollToVariant",
    value: function handleScrollToVariant(e) {
      var button = e.target.closest(SELECTORS.SCROLL_TO_VARIANT);
      if (!button) return;
      var variantSerial = button.dataset.serial;
      var variantColumn = document.querySelector("".concat(SELECTORS.VARIANT_COLUMN, "[data-serial=\"").concat(variantSerial, "\"]"));
      if (!variantColumn) return;
      var serialLink = variantColumn.querySelector(SELECTORS.SELECT_LINK);
      if (!serialLink) return;
      serialLink.click();
    }

    /**
     * Handle the click event for 'Add to Cart' button
     * @param {MouseEvent} e
     */
  }, {
    key: "handleAddToCart",
    value: function handleAddToCart(e) {
      var _this3 = this;
      var button = e.target.closest(SELECTORS.ADD_TO_CART);
      if (!button) return;
      var closestSelectVariant = button.closest('.serialisation-modal__button-group').querySelector(SELECTORS.SELECT_VARIANT);
      this.dispatchEvent(new CustomEvent(EVENTS.ADD_TO_CART, {
        detail: {
          serial: button.dataset.serial
        },
        bubbles: true,
        composed: true
      }));
      window.subscribe(window.PUB_SUB_EVENTS.cartError, function (response) {
        if (response.message) {
          var errorMessage = _this3.querySelector(SELECTORS.ERROR_MESSAGE);
          if (errorMessage) {
            errorMessage.textContent = response.message;
          }
        }
      });
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (response) {
        if (response.cartData) {
          var isDesktop = !_this3.isMobile;
          if (isDesktop) {
            var _this3$querySelector;
            (_this3$querySelector = _this3.querySelector(SELECTORS.CLOSE_BUTTON)) === null || _this3$querySelector === void 0 || _this3$querySelector.click();
            setTimeout(function () {
              if (closestSelectVariant) {
                closestSelectVariant.click();
              }
            }, 50);
          }
        }
      });
    }

    /**
     * Update variant selection UI
     * @param {string} serial
     * @param {HTMLElement} selectedButton
     */
  }, {
    key: "updateVariantSelectionUI",
    value: function updateVariantSelectionUI(serial, selectedButton) {
      var _this4 = this,
        _selectedColumn$query;
      var allSelectButtons = this.querySelectorAll(SELECTORS.SELECT_VARIANT);
      allSelectButtons.forEach(function (btn) {
        if (_this4.isMobile) {
          btn.textContent = 'Select Guitar';
        } else {
          btn.textContent = 'Select Guitar';
        }
        btn.classList.remove('selected');
      });
      if (this.isMobile) {
        selectedButton.textContent = 'Currently Selected';
      } else {
        selectedButton.textContent = 'Selected';
      }
      selectedButton.classList.add('selected');
      document.querySelectorAll("".concat(SELECTORS.VARIANT_COLUMN, "[data-serial]")).forEach(function (element) {
        var _element$querySelecto;
        element.setAttribute('data-selected', false);
        (_element$querySelecto = element.querySelector('[data-selected]')) === null || _element$querySelecto === void 0 || _element$querySelecto.setAttribute('data-selected', false);
        /* remove all elements with the class visible */
        element.querySelectorAll(".".concat(CLASSES.VISIBLE)).forEach(function (visibleElement) {
          visibleElement.classList.remove(CLASSES.VISIBLE);
        });
      });
      var selectedColumn = document.querySelector("".concat(SELECTORS.VARIANT_COLUMN, "[data-serial=\"").concat(serial, "\"]"));
      selectedColumn === null || selectedColumn === void 0 || selectedColumn.setAttribute('data-selected', true);
      selectedColumn === null || selectedColumn === void 0 || (_selectedColumn$query = selectedColumn.querySelector('[data-selected]')) === null || _selectedColumn$query === void 0 || _selectedColumn$query.setAttribute('data-selected', true);
      var classesToLookForAndAddVisible = ['serialisation-modal__variant-image', 'serialisation-modal__attributes', 'serialisation-modal__select-group--mobile', 'serialisation-modal__variant-image-wrapper'];
      classesToLookForAndAddVisible.forEach(function (className) {
        var _ref;
        (_ref = _toConsumableArray(selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.querySelectorAll(".".concat(className)))) === null || _ref === void 0 || _ref.forEach(function (element) {
          element.classList.add(CLASSES.VISIBLE);
        });
      });

      /* Find corresponding scroll to variant and add 'selected' class, and remove 'selected' class from all other scroll to variants */
      var allScrollToVariants = document.querySelectorAll(SELECTORS.SCROLL_TO_VARIANT);
      allScrollToVariants.forEach(function (variant) {
        variant.classList.remove('selected');
      });
      var correspondingScrollToVariant = document.querySelector("".concat(SELECTORS.SCROLL_TO_VARIANT, "[data-serial=\"").concat(serial, "\"]"));
      correspondingScrollToVariant === null || correspondingScrollToVariant === void 0 || correspondingScrollToVariant.classList.add('selected');
      var isDesktop = !this.isMobile;
      if (isDesktop) {
        this.triggerVariantChange();
        setTimeout(function () {
          _this4.cleanup(false);
        }, 500);
      }
    }

    /**
     * Handle selecting a variant within the modal
     * @param {MouseEvent} e
     */
  }, {
    key: "handleSelectVariant",
    value: function handleSelectVariant(e) {
      var button = e.target.closest(SELECTORS.SELECT_VARIANT);
      if (!button) return;
      var _button$dataset = button.dataset,
        serial = _button$dataset.serial,
        variantId = _button$dataset.variantId;
      var variantSelects = document.querySelector(SELECTORS.VARIANT_SELECTS);
      if (!variantSelects) return;
      var variantInput = variantSelects.querySelector("input[data-variant-id=\"".concat(variantId, "\"]"));
      if (!variantInput) return;
      variantInput.checked = true;
      this.currentVariantSerial = serial;
      this.updateVariantSelectionUI(serial, button);
    }

    /**
     * Handle the click event for the close button
     * @param {MouseEvent} e
     */
  }, {
    key: "handleCloseClick",
    value: function handleCloseClick(e) {
      if (e.target.closest(SELECTORS.CLOSE_BUTTON)) {
        this.cleanup();
      }
    }

    /**
     * Handle the click event for the mobile select variant
     * @param {MouseEvent} e
     */
  }, {
    key: "handleMobileSelectVariant",
    value: function handleMobileSelectVariant(e) {
      var button = e.target.closest(SELECTORS.MOBILE_SELECT_VARIANT);
      if (!button) return;
      if (this.isMobile) {
        var serial = button.getAttribute('js-mobile-select-variant');
        var serialLink = document.querySelector("select-link[data-serial=\"".concat(serial, "\"]"));
        if (!serialLink) return;
        serialLink.click();
      } else {
        var variantSelects = document.querySelectorAll('[js-select-variant]');
        var _serial = button.getAttribute('js-mobile-select-variant');
        variantSelects.forEach(function (variantSelect) {
          if (variantSelect.dataset.serial === _serial && variantSelect.nodeName !== 'SELECT-LINK') {
            variantSelect.click();
          }
        });
      }
    }

    /**
     * Set up event listeners for the modal
     */
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      this.isMobile = window.matchMedia('(max-width: 48rem)').matches;
      var once = this.isMobile ? {
        once: true
      } : {};
      this.addEventListener(EVENTS.CLICK, this.handleOutsideClick, once);
      this.addEventListener(EVENTS.CLICK, this.handleAddToCart);
      this.addEventListener(EVENTS.CLICK, this.handleSelectVariant);
      this.addEventListener(EVENTS.CLICK, this.handleCloseClick);
      this.addEventListener(EVENTS.CLICK, this.handleScrollToVariant);
      this.addEventListener(EVENTS.CLICK, this.handleMobileSelectVariant, {
        once: true
      });
      document.addEventListener(EVENTS.KEYDOWN, this.handleKeydown);
    }
  }, {
    key: "triggerVariantChange",
    value: function triggerVariantChange() {
      var _this$parentElement;
      var closestVariantSelects = (_this$parentElement = this.parentElement) === null || _this$parentElement === void 0 || (_this$parentElement = _this$parentElement.parentElement) === null || _this$parentElement === void 0 ? void 0 : _this$parentElement.querySelector(SELECTORS.VARIANT_SELECTS);
      if (this.originalVariantSerial !== this.currentVariantSerial) {
        closestVariantSelects === null || closestVariantSelects === void 0 || closestVariantSelects.dispatchEvent(new Event(EVENTS.CHANGE, {
          bubbles: false
        }));
      }
    }

    /**
     * Clean up the modal, remove listeners, and restore body scroll
     */
  }, {
    key: "cleanup",
    value: function cleanup() {
      var toTriggerVariantChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (toTriggerVariantChange) {
        this.triggerVariantChange();
      }
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open');
      this.removeEventListeners();
      this.classList.add('hidden');
      if (this.lazyLoad) {
        this.lazyLoad.destroy();
      }
      this.originalVariantSerial = this.currentVariantSerial;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define(SELECTORS.MODAL, SerialisationModal);

/**
 * Subscribe to the variant change event
 */
subscribe(EVENTS.VARIANT_CHANGE, function () {
  var modal = document.querySelector(SELECTORS.MODAL);
  if (modal && !modal.classList.contains('hidden')) {
    modal.initializeLazyLoad();
  }
});

/**
 * Custom element for the select link button in the serialization modal
 * @extends HTMLElement
 */
var SelectLink = /*#__PURE__*/function (_HTMLElement2) {
  function SelectLink() {
    _classCallCheck(this, SelectLink);
    return _callSuper(this, SelectLink);
  }

  /**
   * Set disabled state and update button appearance
   * @param {boolean} value
   */
  _inherits(SelectLink, _HTMLElement2);
  return _createClass(SelectLink, [{
    key: "disabled",
    get:
    /**
     * Get disabled state
     * @returns {boolean}
     */
    function get() {
      return this.hasAttribute('disabled');
    },
    set: function set(value) {
      if (value) {
        this.setAttribute('disabled', '');
      } else {
        this.removeAttribute('disabled');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('select-link', SelectLink);
}();
/******/ })()
;